import { render, staticRenderFns } from "./addUserInfo.vue?vue&type=template&id=68d32fe1&scoped=true&"
import script from "./addUserInfo.vue?vue&type=script&lang=js&"
export * from "./addUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./addUserInfo.vue?vue&type=style&index=0&id=68d32fe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d32fe1",
  null
  
)

export default component.exports